const Image = ({ stroke, fill, ...props }) => (
  <svg width="22" height="23" viewBox="0 0 22 23" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      id="styled-element"
      d="M18.5625 4.53101H3.4375C3.0578 4.53101 2.75 4.83881 2.75 5.21851V17.5935C2.75 17.9732 3.0578 18.281 3.4375 18.281H18.5625C18.9422 18.281 19.25 17.9732 19.25 17.5935V5.21851C19.25 4.83881 18.9422 4.53101 18.5625 4.53101Z"
      stroke={stroke || fill || 'currentColor'}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.75 14.8434L7.07266 10.5208C7.13663 10.4558 7.21288 10.4042 7.29698 10.369C7.38107 10.3338 7.47133 10.3157 7.5625 10.3157C7.65367 10.3157 7.74393 10.3338 7.82802 10.369C7.91212 10.4042 7.98837 10.4558 8.05234 10.5208L11.8852 14.3536C11.9491 14.4185 12.0254 14.4701 12.1095 14.5053C12.1936 14.5406 12.2838 14.5587 12.375 14.5587C12.4662 14.5587 12.5564 14.5406 12.6405 14.5053C12.7246 14.4701 12.8009 14.4185 12.8648 14.3536L14.6352 12.5833C14.6991 12.5183 14.7754 12.4667 14.8595 12.4315C14.9436 12.3963 15.0338 12.3782 15.125 12.3782C15.2162 12.3782 15.3064 12.3963 15.3905 12.4315C15.4746 12.4667 15.5509 12.5183 15.6148 12.5833L19.25 16.2184"
      stroke={stroke || fill || 'currentColor'}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.4062 10.031C13.9758 10.031 14.4375 9.5693 14.4375 8.99976C14.4375 8.43021 13.9758 7.96851 13.4062 7.96851C12.8367 7.96851 12.375 8.43021 12.375 8.99976C12.375 9.5693 12.8367 10.031 13.4062 10.031Z"
      fill={stroke || fill || 'currentColor'}
    />
  </svg>
);

export default Image;
